import React, { Component } from 'react';

import StringUtils from '../../services/StringUtils.js';

import '../../../css/FilterMenu.css';
import '../../../css/SearchBar.css';

const neutralElement = 'ALL';

class FilterMenu extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      title: props.title,
      items: this.addNeutralElement(props.items),
      open: props.open,
      selectedItem: []
    }

    this.toggle = props.toggle;
    this.selectCb = props.select;

  }

  componentWillReceiveProps(newProps) {
    this.setState({
      title: newProps.title,
      items: this.addNeutralElement(newProps.items),
      selectedItem: newProps.selectedItem || [],
      open: newProps.open
    });

  }

  addNeutralElement(items) {
    return [neutralElement].concat(items);
  }

  toggleState(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.toggle(this.state.title);
  }

  select(item, evt) {

    evt.preventDefault();
    evt.stopPropagation();

    let selectedItems = this.state.selectedItem;

    let index = selectedItems.indexOf(item);

    if (item === neutralElement)
      item = [];
    else if (index === -1) {
      item = selectedItems.concat(item);
    }
    else {
      item = selectedItems.concat([]);
      item.splice(index, 1);
    }
    

    this.selectCb(item);
    this.setState({selectedItem: item});
    this.toggle(this.state.title);
  }

  render() {

    let title = this.state.title;
    let items = this.state.items;

    let open = this.state.open;

    let menuIcon = open ? 'icon-angle-up' : 'icon-angle-down';

    let menuItems = items.map((item) => {
      let selectedItem = this.state.selectedItem;
      let active = (selectedItem.indexOf(item) > -1) || (item === neutralElement && selectedItem.length === 0) ? 'active' : '';
      return <li onClick={this.select.bind(this, item)} className={`clickable filterItem ${active}`} key={item}>{StringUtils.titleize(item)}</li>
    });

    return (
      <div className={`filterMenu ${open ? 'active' : 'inactive'}`}>
        <div className="header" onClick={this.toggleState.bind(this)}>
          <label className="filterMenuTitle">{StringUtils.titleize(title)}</label>
          <i className={`menuIcon fontastic ${menuIcon}`}></i>
        </div>
        {this.state.open && <ul className="filterList">
          {menuItems}
        </ul>}

      </div>
    );

  }

}

export default FilterMenu;



// WEBPACK FOOTER //
// ./src/js/components/filter/FilterMenu.jsx